<template>
    <div class="table-responsive" :style="{ maxHeight: maxHeight}">
        <table class="table table-hover table-responsive-sm">
            <thead>
                <tr class="stack">
                    <th v-for="(key, index) in columns"
                        :key="index"
                        :class="{ active: sortKey == key }">
                        {{ $t(captions[key]) }}
                        <span class="pointer" :class="sortKey == key ? 'text-success' : 'text-secondary'" @click.stop="sortBy(key)">
                            <i :class="sortOrders[key] > 0 ? 'fas fa-caret-down' : 'fas fa-caret-up'"></i>
                        </span>
                    </th>
                    <th v-if="btns">
                        {{$t('actions')}}
                    </th>
                </tr>
            </thead>
            <tbody v-if="usedForRelatedForms">
                <related-forms-grid-item v-for="item1 in filteredData"
                                         :key="item1.id"
                                         :columns="columns"
                                         :item="item1"
                                         :btns="btns"
                                         :gridName="gridName"
                                         :editableColumns="editableColumns"
                                         :dateFormat="dateFormat"
                                         :dateColumns="dateColumns"
                                         :readonly="readonly">
                </related-forms-grid-item>
            </tbody>
            <tbody v-else>
                <grid-item v-for="item in filteredData"
                           :key="item.id"
                           :columns="columns"
                           :html-columns="htmlColumns"
                           :item="item"
                           :btns="btns"
                           :gridName="gridName"
                           :editableColumns="editableColumns"
                           :dateFormat="dateFormat"
                           :dateColumns="dateColumns"
                           :readonly="readonly"
                           :options="options"
                           :captions="captions">
                </grid-item>
            </tbody>
            <tfoot>

            </tfoot>
        </table>
    </div>
</template>

<script>
    import GridItem from "./CustomGridItem"
    import RelatedFormsGridItem from "./RelatedFormsCustomGridItem"

    export default {
        name: 'custom-grid',
        components: {
            GridItem,
            RelatedFormsGridItem
        },
        props: {
            data: Array,
            columns: Array,
            htmlColumns: Array,
            filterKey: String,
            captions: Object,
            btns: Array,
            gridName: {
                type: String
            },
            editableColumns: Array,
            maxHeight: {
                type: String,
                default: '800px'
            },
            dateFormat: {
                type: String,
                default: ''
            },
            dateColumns: Array,
            readonly: {
                type: Boolean,
                default: false
            },
            usedForRelatedForms: {
                type: Boolean,
                default: false
            },
            options: {} // { columnName: { inputType: '', } }
        },
        data() {
            return {
                sortKey: '',
                sortOrders: {}
            };
        },
        mounted() {
            this.columns.forEach(function (key) {
                this.sortOrders[key] = 1;
            }.bind(this));
        },
        methods: {
            sortBy(key) {
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;
            }
        },
        computed: {
            filteredData() {
                const sortKey = this.sortKey;
                const filterKey = this.filterKey && this.filterKey.toLowerCase();
                let order = this.sortOrders[sortKey] || 1;
                let data = this.data;
                if (filterKey) {
                    data = data.filter(function (row) {
                        return Object.keys(row).some(function (key) {
                            return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                        });
                    });
                }
                if (sortKey) {
                    data = data.slice().sort(function (a, b) {
                        a = a[sortKey];
                        b = b[sortKey];
                        return (a === b ? 0 : a > b ? 1 : -1) * order;
                    });
                }
                return data;
            }
        }
    };
</script>

<style>

    th.active {
        border-bottom-width: medium !important;
        border-bottom-color: #42b983 !important;
    }

        th.active .arrow {
            opacity: 1;
        }

    .arrow {
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 0;
        margin-left: 5px;
        opacity: 0.66;
    }

        .arrow.asc {
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-bottom: 4px solid #fff;
        }

        .arrow.dsc {
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 4px solid #fff;
        }
</style>
